import { render, staticRenderFns } from "./TrainPage.vue?vue&type=template&id=bd300f9e&scoped=true"
import script from "./TrainPage.vue?vue&type=script&lang=js"
export * from "./TrainPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd300f9e",
  null
  
)

export default component.exports